var map = {
	"./about/content.md": "d704",
	"./about/landing.jpg": "2cab",
	"./business/cover-1.jpg": "ad24",
	"./business/cover-2.jpg": "e76b",
	"./business/cover-3.jpg": "9de9",
	"./business/cover-4.jpg": "5004",
	"./business/detail/asset.ext.md": "adbe",
	"./business/detail/build.ext.md": "3def",
	"./business/detail/commerce.ext.md": "1b0d",
	"./business/detail/detail-1.jpg": "8660",
	"./business/detail/detail-2.jpg": "2301",
	"./business/detail/detail-3.jpg": "1643",
	"./business/detail/detail-4.jpg": "ed14",
	"./business/detail/detail-5.jpg": "ed6d",
	"./business/detail/detail-6.jpg": "ff81",
	"./business/detail/detail-7.png": "347e",
	"./business/detail/education.ext.md": "fbd6",
	"./business/landing.jpg": "b5c7",
	"./business/sample/20181029/content.md": "7b3f",
	"./business/sample/20181029/cover.jpg": "65bf",
	"./business/sample/20181109/content.md": "c48b",
	"./business/sample/20181109/cover.jpg": "b7b3",
	"./business/sample/20181109/img1.jpg": "6b15",
	"./home/carousel-1.jpg": "51ab",
	"./home/carousel-2.jpg": "d31a",
	"./home/carousel-3.jpg": "793d",
	"./logo.png": "cf05",
	"./news/config": "0e50",
	"./news/config.js": "0e50",
	"./news/landing.jpg": "6b83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";